import { useCurrentRefinements, useRange } from "react-instantsearch-hooks-web";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import CurrencyInput from "react-currency-input-field";
import { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

function PriceRangeRefinement({ listingType }) {
  // console.log(listingType)
  const { start, range, canRefine, refine, sendEvent } = useRange({
    attribute: listingType === "Rent" ? "monthlyRent" : "price",
    min: undefined,
    max: undefined,
  });
  // console.log(listingType);
  const [open, setOpen] = useState(false);
  const [min, setMin] = useState(undefined);
  const [max, setMax] = useState(undefined);
  const props = useCurrentRefinements();
  // console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  // console.log(itemRefs);
  const arr = itemRefs.find((c) =>
    (c.attribute === listingType) === "Rent" ? "monthlyRent" : "price"
  );
  // console.log(arr);
  // console.log(arr);
  // console.log(listingType);
  return (
    <>
      <DropdownMenu.Root
        open={open}
        onOpenChange={(value) => {
          if (!value) {
            setOpen(false);
            refine([min, max]);
          } else {
            setOpen(true);
          }
        }}
      >
        <DropdownMenu.Trigger asChild>
          <button className=" flex cursor-pointer select-none flex-row space-x-0 rounded border border-gray-400 bg-white px-3 py-2 text-sm text-gray-900 lg:space-x-1 lg:px-5 lg:py-3">
            <span>Budget</span>
            <IoMdArrowDropdown className=" h-5 w-5 text-gray-700" />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={2}
            className=" z-20 h-auto w-auto rounded-md border border-gray-300 bg-white px-6 pb-6 pt-5 shadow-md"
          >
            <DropdownMenu.Label className=" text-sm text-gray-600">
              Budget
            </DropdownMenu.Label>
            <div className=" mt-2 flex flex-col items-center space-y-4 lg:flex-row lg:space-x-2 lg:space-y-0">
              <CurrencyInput
                id="min"
                name="input-min"
                placeholder="Enter min"
                className="rounded-md border  border-gray-400 px-4 py-2"
                allowDecimals={false}
                allowNegativeValue={false}
                // disableAbbreviations={}
                min={1}
                value={min >= 1 ? min : ""}
                prefix="Kshs "
                onValueChange={(value, name) => {
                  setMin(parseInt(value));
                }}
              />
              <div className=" hidden lg:flex">-</div>
              <CurrencyInput
                id="max"
                name="input-max"
                placeholder="Enter max"
                className="  rounded-md border  border-gray-400 px-4 py-2"
                allowDecimals={false}
                allowNegativeValue={false}
                min={1}
                value={max ? max : ""}
                prefix="Kshs "
                onValueChange={(value, name) => {
                  setMax(parseInt(value));
                }}
              />
            </div>
            <div className="mt-4 flex flex-row justify-between">
              <span></span>
              <div className="flex flex-row items-center space-x-6">
                <span
                  className=" cursor-pointer text-sm hover:text-zote-primary"
                  onClick={() => {
                    setMin(undefined);
                    setMax(undefined);
                    refine([undefined, undefined]);
                    setOpen(false);
                  }}
                >
                  Clear
                </span>
                <button
                  onClick={() => {
                    // console.log(min);
                    // console.log(max);

                    // refine([
                    //   Number.isFinite(min) ? 20000 : undefined,
                    //   Number.isFinite(max) ? 65000 : undefined,
                    // ]);

                    refine([
                      Number.isFinite(min) ? min : undefined,
                      Number.isFinite(max) ? max : undefined,
                    ]);
                    setOpen(false);
                  }}
                  className=" rounded-md bg-zote-primary px-4 py-2 text-white "
                >
                  Done
                </button>
              </div>
            </div>

            <DropdownMenu.Arrow
              className="  fill-gray-200"
              width={10}
              height={5}
            />
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </>
  );
}
export default PriceRangeRefinement;
